import React from 'react';
import Capstone1 from '../images/capstone.png'
// import Capstone2 from '../images/capstone2.png'
// import Capstone3 from '../images/capstone3.png'
import Capstone4 from "../images/capstone4.png"
import Capstone5 from "../images/weather.png"
// import Capstone6 from "../images/covidtracker.png"
// import Capstone7 from "../images/starbuckslocator.png"
// import { Link } from "react-router-dom"
import html5 from '../images/html5.png'
import js from '../images/js.png'
// import laravel from '../images/laravel.png'
// import mysql from '../images/mysql1.png'
// import php from '../images/php.png'
import css from '../images/css.png'
import mongodb from '../images/mongodb.png'
import nodejs from '../images/nodejs.png'
import reactjs from '../images/reactjs.png'
import api from "../images/api.png"
import boots from "../images/boots.png"
import sass from "../images/sass.png"
// import mobiledev from "../images/mobiledev.png"
import quasar from "../images/quasar.svg"
import lexicon from "../images/lexicon.png"
import bitcapp from "../images/bitcapp.png"
import wbuddy from "../images/workout-login-page.png"
import rfordering from "../images/ordering.png"
// import prj from "../objects/project.json"


const project = [
    {
        title: "React Food Order",
        description: "A fullstack application created from MERN Stack. It's a cart system and has authentication feature.",
        technology: "Web Development Technology:",
        tech: [
            {techName: reactjs},
            {techName: api},
            {techName: nodejs},
            {techName: mongodb}
        ],
        link: "https://rfordering.netlify.app",
        imgSrc: rfordering
        },
    {
        title: "Workout Buddy",
        description: "A fullstack application created from MERN Stack. It's workout management and has authentication feature.",
        technology: "Web Development Technology:",
        tech: [
            {techName: reactjs},
            {techName: api},
            {techName: nodejs},
            {techName: mongodb}
        ],
        link: "https://wbuddy.netlify.app/",
        imgSrc: wbuddy
        },
    {
    title: "Bitcapp",
    description: "A static single page application made by Quasar Framework and Sass.",
    technology: "Web Development Technology:",
    tech: [
        {techName: quasar},
        {techName: sass}
    ],
    link: "https://bitcapp.netlify.app/#/",
    imgSrc: bitcapp
    },
    {
    title: "Lexicon Bank Holdings",
    description: "An online banking platform that provides blockchain security.",
    technology: "Web Development Technology:",
    tech: [
        {techName: quasar},
        {techName: api},
        {techName: nodejs},
        {techName: mongodb}
    ],
    link: "https://lexiconbank.holdings",
    imgSrc: lexicon
    },
    // {
    // title: "Starbucks Locator",
    // description: "A simple Store Locator, made from HTML, CSS and Javascript. I used google map api which is Maps Javascript API for this web application.",
    // technology: "Web Development Technology:",
    // tech: [
    //     {techName: html5},
    //     {techName: css},
    //     {techName: js},
    //     {techName: api}
    // ],
    // link: "https://starbuckslocator.netlify.app/",
    // imgSrc: Capstone7
    // },
    {
    title: "Seoul Station Korean Barbeque",
    description: "Seoul Station Korean Barbeque is the number one Samgyeoupsal Restaurant in Malolos Bulacan. It is made by HTML, CSS, Bootstrap and Javascript.",
    technology: "Web Development Technology:",
    tech: [
        {techName: html5},
        {techName: css},
        {techName: boots}
    ],
    link: "https://pergent19.gitlab.io/capstone-1/",
    imgSrc: Capstone1
    },
    // {
    // title: "Fashion Occasion",
    // description: "Fashion Occasion is made by the framework Laravel. It is an Asset Management System.",
    // technology: "Web Development Technology:",
    // tech: [
    //     {techName: laravel},
    //     {techName: mysql},
    //     {techName: boots}
    // ],
    // link: "https://desolate-crag-01389.herokuapp.com/",
    // imgSrc: Capstone2
    // },
    // {
    // title: "Travelora",
    // description: "Travelora is a booking system website. It is a hotel booking system made from Mongodb, ExpressJs, Reactjs and Nodejs.",
    // technology: "Web Development Technology:",
    // tech: [
    //     {techName: reactjs},
    //     {techName: nodejs},
    //     {techName: mongodb},
    //     {techName: boots}
    // ],
    // link: "https://travelora.netlify.app/",
    // imgSrc: Capstone3
    // },
    {
    title: "Boss Burger",
    description: "Boss Burger is made by HTML, SASS, and Javascript. It is only a static website",
    technology: "Web Development Technology:",
    tech: [
        {techName: html5},
        {techName: sass},
        {techName: js},
    ],
    link: "https://restaurant-food.netlify.app/",
    imgSrc: Capstone4
    },
    {
    title: "Weather Application",
    description: "A simple Weather Web Application, made by reactjs. I used OpenWeather for getting free access to main weather parameters such as current weather, forecast and historical weather with only one call to API.",
    technology: "Web Development Technology:",
    tech: [
        {techName: reactjs},
        {techName: css},
        {techName: api},
    ],
    link: "https://pergentweatherapp.netlify.app/",
    imgSrc: Capstone5
    },
    // {
    // title: "Corona Tracker",
    // description: "A simple Covid19 Data and Case Tracker, made by reactjs. Tracking all the confirmed cases, deaths and recovered data world wide using API.",
    // technology: "Web Development Technology:",
    // tech: [
    //     {techName: reactjs},
    //     {techName: css},
    //     {techName: api},
    // ],
    // link: "https://pergent-covid19-tracker.netlify.app/",
    // imgSrc: Capstone6
    // },
]



const Project = () => {
    return (
        <section id="project">
            <div className="container mb-5">
                <div className="col-sm-12 py-5 ">
                    <h1 className="mt-5 text-center text-black wow bounceInLeft project" data-wow-delay="0.3s" data-wow-duration="1s" id="project">My Projects</h1><br />
                    <center>
                        <div className="nbsp3 wow bounceInRight" data-wow-delay="0.3s" data-wow-duration="1s"></div>
                    </center>

                </div>
                <div className="row align-items-center no-gutters mb-4 mb-lg-5" id="container-2">

                {project.map((proj, key) => {
                       return(
                        <div className="row mb-5" key={key}>
                        <div className="col-xl-8 col-lg-7  wow bounceInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                            <a href={proj.imgSrc} data-lightbox="image-1.0"><img className="img-fluid mb-3 mb-lg-0" id="photos" src={proj.imgSrc} alt=".."></img></a>
                        </div>

                        <div className="col-xl-4 col-lg-5  wow bounceInRight" data-wow-delay="0.3s" data-wow-duration="1s">
                            <div className="featured-text2 text-center text-lg-left">
                                <h4 className="title">{proj.title}</h4>
                                <p className="text-black-50 mb-0 description" >{proj.description}</p>
                                <div className="tech-icon-container">
                                    <h4 className="title">{proj.technology}</h4>
                                    {proj.tech.map((p, k) => {
                                            return <img src={p.techName} alt="" className="techicon" key={k} />
                                        })}
                                </div>
                                <a href={proj.link} className="description-btn  btn btn-danger" target="_blank" rel="noopener noreferrer">View Site</a>
                            </div>
                        </div>
                    </div>
                   ) 
                })}
                </div>
            </div>
        </section >

    )
}

export default Project;